import { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import api from '../services/api';

export default function RenewalBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get('/pagamento/minha-assinatura')
      .then(r => setInfo(r.data))
      .catch(() => {});
  }, []);

  if (!info) return null;
  if (info.periodo_cobranca === 'teste') return null;
  if (info.dias_restantes === null || info.dias_restantes === undefined) return null;
  if (info.dias_restantes > 3) return null;
  if (info.status_vencimento === 'vencida') return null; // já suspenso, outro aviso

  const diasLabel = info.dias_restantes <= 0
    ? 'hoje'
    : info.dias_restantes === 1
      ? 'amanhã'
      : `em ${info.dias_restantes} dias`;

  const bg = info.dias_restantes <= 1 ? '#7f1d1d' : '#78350f';
  const accent = info.dias_restantes <= 1 ? '#fca5a5' : '#fcd34d';

  return (
    <div style={{
      background: bg,
      color: '#fff',
      padding: '6px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 8,
      fontSize: 13,
      lineHeight: 1.3,
      flexWrap: 'nowrap',
      minHeight: 36,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0 }}>
        <AlertTriangle size={14} color={accent} style={{ flexShrink: 0 }} />
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          Assinatura <strong>{info.plano}</strong> vence <strong>{diasLabel}</strong>
        </span>
      </div>
      <a
        href="https://disparaia.net/#precos"
        target="_blank"
        rel="noreferrer"
        style={{
          background: '#fff',
          color: bg,
          padding: '3px 10px',
          borderRadius: 5,
          fontWeight: 700,
          fontSize: 12,
          textDecoration: 'none',
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        Renovar
      </a>
    </div>
  );
}
